import { Link, useNavigate } from 'react-router-dom'
import { ArrowLeft, ChevronRight, FilePen, FileText, MessageSquare, Type } from 'lucide-react'
import { trpc } from '@/trpc/client'

export function SettingsPage() {
	const navigate = useNavigate()
	// Hidden unless the server runs with SMS_REMINDERS_ENABLED=true (also
	// while loading or on error — the card never flashes)
	const smsReminders = trpc.smsReminders.getStatus.useQuery(undefined, {
		staleTime: 5 * 60_000,
	})

	return (
		<div className="min-h-screen bg-[#faf8f5]">
			<div className="mx-auto max-w-3xl px-6 py-6">
				<div className="mb-6 flex items-center justify-between">
					<button
						type="button"
						onClick={() => navigate(-1)}
						className="inline-flex items-center gap-2 text-[#5c5142] hover:text-[#3d3428] transition-colors"
					>
						<ArrowLeft className="h-4 w-4" />
						<span>Zpět</span>
					</button>
					<h1 className="text-2xl font-semibold text-[#3d3428]">Nastavení</h1>
					<div className="w-16" />
				</div>

				<div className="space-y-3">
					<Link
						to="/settings/font-size"
						className="flex items-center justify-between rounded-xl border border-[#e8e4df] bg-white px-5 py-4 hover:border-[#d7ad6c] hover:bg-[#faf8f5] transition-colors"
					>
						<div className="flex items-center gap-4">
							<span className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#f5ebe0]">
								<Type className="h-5 w-5 text-[#d7ad6c]" />
							</span>
							<div>
								<div className="font-medium text-[#3d3428]">
									Velikost písma a prvků
								</div>
								<div className="text-sm text-[#6b5c4c]">
									Nastavení velikosti textu, polí a dalších prvků v aplikaci
								</div>
							</div>
						</div>
						<ChevronRight className="h-5 w-5 text-[#a09689]" />
					</Link>
					<Link
						to="/settings/weekly-report"
						className="flex items-center justify-between rounded-xl border border-[#e8e4df] bg-white px-5 py-4 hover:border-[#d7ad6c] hover:bg-[#faf8f5] transition-colors"
					>
						<div className="flex items-center gap-4">
							<span className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#f5ebe0]">
								<FileText className="h-5 w-5 text-[#d7ad6c]" />
							</span>
							<div>
								<div className="font-medium text-[#3d3428]">Týdenní report</div>
								<div className="text-sm text-[#6b5c4c]">
									PDF s pacienty, kteří tento týden přišli, a jejich dalším termínem
								</div>
							</div>
						</div>
						<ChevronRight className="h-5 w-5 text-[#a09689]" />
					</Link>
					<Link
						to="/settings/pdf-texts"
						className="flex items-center justify-between rounded-xl border border-[#e8e4df] bg-white px-5 py-4 hover:border-[#d7ad6c] hover:bg-[#faf8f5] transition-colors"
					>
						<div className="flex items-center gap-4">
							<span className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#f5ebe0]">
								<FilePen className="h-5 w-5 text-[#d7ad6c]" />
							</span>
							<div>
								<div className="font-medium text-[#3d3428]">Texty v PDF</div>
								<div className="text-sm text-[#6b5c4c]">
									Hlavička a patička dotazníku a objednacího listu
								</div>
							</div>
						</div>
						<ChevronRight className="h-5 w-5 text-[#a09689]" />
					</Link>
					{smsReminders.data?.enabled && (
						<Link
							to="/settings/sms-reminders"
							className="flex items-center justify-between rounded-xl border border-[#e8e4df] bg-white px-5 py-4 hover:border-[#d7ad6c] hover:bg-[#faf8f5] transition-colors"
						>
							<div className="flex items-center gap-4">
								<span className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#f5ebe0]">
									<MessageSquare className="h-5 w-5 text-[#d7ad6c]" />
								</span>
								<div>
									<div className="font-medium text-[#3d3428]">SMS připomínky</div>
									<div className="text-sm text-[#6b5c4c]">
										Automatická SMS pacientům před termínem – kolik dní předem a text zprávy
									</div>
								</div>
							</div>
							<ChevronRight className="h-5 w-5 text-[#a09689]" />
						</Link>
					)}
				</div>
			</div>
		</div>
	)
}

export default SettingsPage
